import { ContactShadows, Environment, Float, Lightformer } from "@react-three/drei";
import SkySphere from "./skysphere/SkySphere";
import hdrTexture from "./textures/empty_warehouse_01_1k.hdr";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { useMemo } from "react";
import { MathUtils, BackSide } from "three";
import { useSnapshot } from "valtio";
import store from "../../appStore";

const Background = ({ ...props }) => {
  const { environmentRotation } = useSnapshot(store);

  return (
    <>
      <SkySphere />
      <Environment
        // files={hdrTexture}
        key={environmentRotation}
        resolution={512}
        frames={1}
        // background
      >
        <Lightformers />
      </Environment>

      {/* <ambientLight intensity={0.75} /> */}

      {/* <ContactShadows
        opacity={1}
        scale={50}
        blur={1}
        far={10}
        resolution={256}
        color="#000000"
        position={[0, -0.01, 0]}
        frames={120}
        renderOrder={10}
      /> */}
    </>
  );
};

function Lightformers({ positions = [2, 0, 2, 0, 2, 0, 2, 0] }) {
  // const group = useRef();
  // useFrame(
  //   (state, delta) =>
  //     (group.current.position.z += delta * 10) > 20 &&
  //     (group.current.position.z = -60)
  // );
  const { environmentRotation } = useSnapshot(store);

  const rails = useMemo(() => {
    const start = -10;
    let rails = [];
    for (let index = start; index < 20; index++) {
      rails.push(index);
    }
    return rails;
  }, []);

  return (
    <group rotation={[0, MathUtils.degToRad(environmentRotation), 0]}>
      {/* Ceiling */}
      <Lightformer rotation-x={Math.PI / 2} position={[0, 5, -9]} scale={[5, 5, 1]} intensity={5} form="ring" color="#caedf1" />

      {/* Front */}
      <Lightformer
        // rotation-x={Math.PI / 2}
        position={[0, 3, 9]}
        scale={[5, 5, 1]}
        intensity={5}
        form="ring"
        color="#ddf2f5"
      />

      <group rotation-y={Math.PI / 2} position={[-5, 2, -1]}>
        {rails.map((r, i) => (
          <Lightformer
            key={`Rail_${i}`}
            rotation-x={MathUtils.degToRad(20)}
            rotation-z={MathUtils.degToRad(20)}
            position={[r * 1, 0, 0]}
            scale={[0.1 * (i % 3) * 2, 10, 1]}
            color="#9bcc8f"
            intensity={3}
          />
        ))}
      </group>

      <group rotation-y={Math.PI / 2} position={[5, 2, -1]}>
        {rails.map((r, i) => (
          <Lightformer
            key={`Rail_puple${i}`}
            rotation-x={MathUtils.degToRad(20)}
            rotation-z={MathUtils.degToRad(20)}
            position={[r * 1, 0, 0]}
            scale={[0.1 * (i % 3) * 2, 10, 1]}
            color="#e7d9e9"
            intensity={3}
          />
        ))}
      </group>

      <mesh>
        <sphereGeometry args={[100]} />
        <meshBasicMaterial color="#4b4b4b" side={BackSide} />
      </mesh>

      {/* <Lightformer
        form="ring"
        color="#e6b3fa"
        intensity={2}
        scale={4}
        position={[-15, 4, -18]}
        target={[0, 0, 0]}
      /> */}
    </group>
  );
}

export default Background;
